export type ThemePreference = "light" | "dark" | "system";

export type ResolvedTheme = "light" | "dark";

export const resolveTheme = (
  preference: ThemePreference | undefined,
  prefersDark: boolean,
): ResolvedTheme =>
  preference === "light" || preference === "dark" ? preference : prefersDark ? "dark" : "light";

export const toggleThemePreference = (
  preference: ThemePreference | undefined,
  prefersDark: boolean,
): ThemePreference | undefined => {
  const next = resolveTheme(preference, prefersDark) === "dark" ? "light" : "dark";
  const system = prefersDark ? "dark" : "light";
  return next === system ? undefined : next;
};

export const applyTheme = (theme: ResolvedTheme): void => {
  document.documentElement.dataset.theme = theme;
};
